import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 銷貨單 Detail（含 lines／allocations／extra_items／金額／出貨地址）。
 *
 * @param {string} id
 */
export async function fetchSalesOrderDetail(id) {
  const { data: raw } = await request.get(`/crm/sales-order/${id}`);
  return parseVer4DetailResponse(raw);
}
